export function getAllArticulationAgreements(articSys, articAgr) {
  return [].concat(articSys.map((name) => ({ name }))).concat(articAgr);
}

export function formatPhoneNumber(s) {
  const s2 = (s || '').replace(/\D/g, '');
  const m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
  return !m ? null : `(${m[1]}) ${m[2]}-${m[3]}`;
}

export function getApplicationDeadlines(deadlines) {
  return deadlines.filter((deadline) => {
    try {
      if (
        JSON.parse(deadline.month) !== null &&
        JSON.parse(deadline.day) !== null &&
        !isNaN(deadline.month) &&
        !isNaN(deadline.day)
      ) {
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  });
}
